<template>
  <div class="my-container">
    <v-card class="content-card mx-auto mb-10">
      <v-card-text class="content-wrapper">
        <div class="find-text size-18 weight8">
          Impressum
        </div>
        <div class="mt-4">
          Angaben gemäß § 5 TMG:
        </div>
        <div class="mt-4">
          Volt.Land ein Produkt der:
        </div>
        <div class="col-flex">
          <span>bellboxx GmbH</span>
          <span>Kellerstrasse 7</span>
          <span>81667 München</span>
        </div>
        <div class="sub-head size-18 weight8 mt-7">
          Kontakt
        </div>
        <div class="col-flex mt-4">
          <span>Telefon: +49 (0) 8955060070</span>
          <span>E-Mail: contact@volt.land</span>
        </div>
        <div class="sub-head size-18 weight8 mt-7">
          Haftung für Inhalte
        </div>
        <div class="mt-4">
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </div>
        <div class="mt-4">
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
        </div>
        <div class="sub-head size-18 weight8 mt-7">
          Haftungsausschluss
        </div>
        <div class="mt-4">
          Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden sind grundsätzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
        </div>
        <div class="sub-head size-18 weight8 mt-7">
          Urheberrecht
        </div>
        <div class="mt-4">
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.  Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        </div>
        <div class="sub-head size-18 weight8 mt-7">
          Quellenhinweise
        </div>
        <div class="mt-4">
          Volt.Land verwendet Bild- und Textmaterial der Automobilhersteller.
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'imprint'
}
</script>

<style lang="scss" scoped>
.my-container {
  background-image: url('~@/assets/img/background3.png');
  background-size: contain;
  padding-top: 110px;
  min-height: 80vh;

  .content-card {
    width: 90%;
    padding: 43px 24px;
    border-radius: 15px !important;

    .content-wrapper {
      padding: 0;
      color: #020B2D;
    }
  }
}
</style>